<template>
  <div class="out-wrap">
    <!-- 新旧版关键词设置 -->
    <el-container class="sen-setting-container">
      <!-- 侧边栏 -->
      <!-- :default-expanded-keys="[currenId]" -->
      <el-aside width="280px" style="padding:0 10px 0 0;">
        <el-tree
          ref="SlotTrees"
          :data="setTree"
          :current-node-key="currenId"
          :default-checked-keys="[currenId]"
          :props="defaultProps"
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="nodeClick"
          default-expand-all
         :node-key="nodeKey"
          :indent="38"
        >
        <!--   :node-key="isNewEdition?'classId':'wordTypeId'" -->
          <div class="comp-tr-node" slot-scope="{ node, data }">
            <template>
              <div class="template">
                <!-- 删除 -->
                <div class="comp-tr-node--btns">
                  <el-button
                    v-if="node.level == 2"
                    icon="el-icon-delete"
                    size="mini"
                    circle
                    type="danger"
                    @click.stop="handleDel(node, data, 1)"
                  ></el-button>
                </div>
                <!-- 名称： 新增节点增加class -->
                <div class="comp-tr-node--name">
                  {{ node.label }}
                </div>
                <!-- 按钮 -->
                <div class="comp-tr-node--btns">
                  <!-- 新增 -->
                  <el-button
                    v-if="node.level == 1"
                    size="mini"
                    type="primary"
                    :disabled="
                      setTree.children && setTree.children.length >= 100
                    "
                    @click.stop="handleAdd(node, data, 1)"
                    >{{ isNewEdition ? "+ 创建词组" : "新增词库" }}</el-button
                  >
                  <!-- <el-button v-if="node.level == 1 && senGroupOption" icon="el-icon-edit"	size="mini"	circle type="info" @click.stop="handleEdit(node, data)"></el-button>
                  <el-button v-if="node.level == 1 && senGroupOption" icon="el-icon-plus" size="mini" circle type="primary"	@click.stop="handleAdd(node, data)"></el-button> -->
                  <!-- 编辑 -->
                  <el-button
                    v-if="node.level == 2"
                    icon="el-icon-edit"
                    size="mini"
                    circle
                    type="info"
                    @click.stop="handleEdit(node, data, 1)"
                  ></el-button>
                  <el-button
                    v-if="node.level == 2 && !isNewEdition"
                    icon="el-icon-plus"
                    circle
                    size="mini"
                    type="primary"
                    @click="handleAdd(node, data, 2)"
                  ></el-button>
                  <el-button
                    v-if="node.level == 3"
                    icon="el-icon-delete"
                    size="mini"
                    circle
                    type="danger"
                    @click.stop="handleDel(node, data, 2)"
                  ></el-button>
                  <el-button
                    v-if="node.level == 3"
                    icon="el-icon-edit"
                    size="mini"
                    circle
                    type="info"
                    @click.stop="handleEdit(node, data, 2)"
                  ></el-button>
                  <!-- 子集 -->
                </div>
              </div>
            </template>
          </div>
        </el-tree>
      </el-aside>
      <div style="border-right: 1px solid #EBEEF5;"></div>
      <el-main class="main-container">
        <!-- 内容区 -->
        <div style="width: 100%;height: 100%;">
          <!-- 头部 -->
          <div class="main-head">
            <el-row>
              <!-- 新增关键词按钮 -->
              <el-col :span="12">
                <el-button
                  size="mini"
                  type="primary"
                  @click="addNewSen"
                  :disabled="
                    isNewEdition
                      ? level == 1 || tableData.length >= 20
                      : level == 0 || level == 2
                  "
                  >添加新词
                  {{
                    isNewEdition
                      ? level == 1
                        ? ""
                        : `${tableData.length}/20`
                      : ""
                  }}</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="dialogVisit = true"
                  >导入新词</el-button
                >
                <span
                  v-if="isNewEdition"
                  class="download-btn"
                  style=""
                  @click="downLoadTemplate"
                  >下载导入模板<i class="el-icon-download"></i
                ></span>
              </el-col>
              <!-- 关键词搜索框 -->
              <!--旧版！！！ 后端新版占用旧版搜索词做列表接口的词组名搜索导致无法兼容，只能另外写一个搜索框进行值绑定！！！ -->
              <el-col
                :span="3"
                style="float:right;margin-bottom:5px"
                v-if="!isNewEdition"
              >
                <el-input
                  size="mini"
                  suffix-icon="el-icon-search"
                  v-model="getSensiListParams.wordName"
                  placeholder="关键词"
                  @blur="onInputBlur"
                  @clear="onInputBlur"
                  clearable
                >
                </el-input>
              </el-col>
              <!--新版！！！ 后端新版占用旧版搜索词做列表接口的词组名搜索导致无法兼容，只能另外写一个搜索框进行值绑定！！！ -->
              <el-col :span="3" style="float:right;margin-bottom:5px" v-else>
                <el-input
                  size="mini"
                  suffix-icon="el-icon-search"
                  v-model="getSensiListParams.keyword"
                  placeholder="关键词"
                  @blur="onInputBlur"
                  @clear="onInputBlur"
                  clearable
                >
                </el-input>
              </el-col>
              <el-col :span="3" style="float:right;" v-if="!isNewEdition">
                <el-button size="mini" type="primary" @click="handleAsyncItem"
                  >手动同步分类词</el-button
                >
              </el-col>
            </el-row>
          </div>
          <!-- 表格区 -->
          <el-row>
            <el-col>
              <el-table
                size="small"
                :data="tableData"
                fit
                highlight-current-row
                align="center"
                :header-cell-style="{ background: '#F9F9F9' }"
                height="calc(100vh - 242px)"
                ref="cusChatTable"
                style="font-size: 13px"
              >
                <el-table-column
                  prop="wordName"
                  label="关键词"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="createBy"
                  label="操作人"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="操作时间"
                  min-width="150"
                ></el-table-column>
                <el-table-column label="操作" min-width="100">
                  <template slot-scope="scope">
                    <!-- <el-button
                      v-if="true"
                      class="table-button"
                      type="text"
                      size="small"
                      @click.native="handleShowSen(scope.$index, scope.row)"
                      >查看</el-button
                    > -->
                    <el-button
                      v-if="true"
                      class="table-button"
                      type="text"
                      size="small"
                      @click.native="handleSenDel(scope.$index, scope.row)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <Pagination
            v-if="!this.isNewEdition"
            :childMsg="pageparm"
            :pageSizes="pageSizes"
            @callBack="callBack"
          ></Pagination>
        </div>
      </el-main>
    </el-container>

    <!-- 旧版新增分类组件 -->
    <!-- <OptionSenWordType
      v-if="!isNewEdition"
      ref="OptionSenWordType"
      @createSuccess="createSuccess"
      :typeTitle="title"
      :types="types"
      :ids="id"
      :editType="editType"
    /> -->

    <!-- 新版新增&编辑分类组件 -->
    <AddOrEditKeyWorkType
      ref="AddOrEditKeyWorkType"
      @createSuccess="createSuccess"
      :typeTitle="title"
      :types="types"
      :ids="id"
      :list="tableData"
      :editType="editType"
      :setTree="setTree"
    />

    <!-- 旧版添加新词组件 -->
    <!-- <AddSensitive
      ref="addSensitive"
      @addSuccess="addSuccess"
      v-if="!isNewEdition"
    ></AddSensitive> -->

    <!-- 新版添加新词组件 -->
    <AddKeyWord ref="addKeyWord" @addSuccess="addSuccess" ></AddKeyWord>

    <!--旧版 关键词导入组件 -->
    <!-- <ImportXls
      v-if="!isNewEdition"
      :dialogVisiImport="dialogVisit"
      @dialogVisiImport="handleVisiImport"
    /> -->

    <!--新版 关键词导入组件 -->
    <KeyWordImport
    
      :dialogVisiImport="dialogVisit"
      @dialogVisiImport="handleVisiImport"
    />
  </div>
</template>

<script>
import {
  getFirstTypeList,
  getConsultList,
  ruleListApi,
  ruleTypeListApi,
  delConsult,
  delFirstType,
  delConsultStore,
  deleteRuleApi,
  asyncItem,
  updateRuleApi,
  ruleListSearchApi,
} from "@/api/keyWords/index.js";
/** 旧版新增&编辑分类组件 */
import OptionSenWordType from "./components/KeyWordSettings/optionSensitiveWordTypeDialog1";
/** 新版新增&编辑词组组件 */
import AddOrEditKeyWorkType from "./components/KeyWordSettings/addOrEditKeyWorkType";
/** 旧版新增关键组件 */
import AddSensitive from "./components/KeyWordSettings/addSensitive";
/** 新版新增关键词组件 */
import AddKeyWord from "./components/KeyWordSettings/addKeyWord";
import { getSessionVersion } from "@/api/staff/staff.js";
/** 旧版的导入组件 */
import ImportXls from "@/components/importXls";
/** 新版导入组件 */
import KeyWordImport from "./components/keyWordImport";
export default {
  name: "component-tree",
  components: {
    OptionSenWordType,
    AddOrEditKeyWorkType,
    AddSensitive,
    ImportXls,
    KeyWordImport,
    AddKeyWord,
  },
  data() {
    return {
      defaultShowNodes: [1], //树形默认展开节点编号
      currenId: "startId",
      setTree: [], // tree数据
      itemTree: [],
      level: 1,
      defaultProps: {
        // 默认设置
        // id: "wordTypeId",
        children: "children",
        label: "wordTypeName",
      },
      // 获取关键词列表参数
      getSensiListParams: {
        pageNum: 1,
        pageSize: 20,
        wordTypeId: "",
        /** 注意！！！！都怪后端乱写， 旧版为搜索字段，新版变为关键词列表接口的分类名称传参 */
        wordName: "",
        classId: "",
        /** 只供新版搜索使用 */
        keyword: "",
      },
      // 关键词表格数据
      tableData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      pageSizes: [20, 50, 100, 200, 500], //分页条数
      wordNames: [], // 所有关键词
      senGroupOption: true, // 可新增、编辑、删除分组
      senOption: true, // 可新增、删除关键词
      dialogVisit: false, //导入新词弹层
      title: "",
      types: 1,
      id: "",
      editType: 1,
      // 是否新版会话存档
      isNewEdition: false,
      /** 控制编辑按钮显示隐藏，悬浮时，编辑按钮因后端分类编辑和关键词删除接口是同一个，
       * 导致获取不到悬浮词组中的关键词，后端无法分辨是编辑词组还是关键词删除，故出此下策
       * 需要结合新旧版进行判断，新版悬浮不显示，旧版显示
       * */
      // isEditBtnShow:false,
      nodeKey:'classId'
    };
  },

  methods: {
    /** 获取新旧版本绘画存档 */
    getVersion() {
      getSessionVersion(localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code === 200) {
          
            this.isNewEdition = res.data;
              this.nodeKey  = this.isNewEdition?'classId':'wordTypeId'
            window.localStorage.setItem("isNewEdition", this.isNewEdition);
            console.log("获取新旧版本成功");
            /** 获取分类列表 */
            this.getSensitiveWordTypeList();
          } else {
            // this.$message.error("获取版本参数失败")
            console.log("新旧版本参数获取失败", err);
          }
        })
        .catch((err) => {
          // this.$message.error("获取版本参数失败")
          console.log("新旧版本参数获取失败", err);
        });
    },

    /**  分类相关   */
    /** 获取分类列表
     * 形参wordTypeName只用于修改分类名称后，
     * 将新修改的名称传值给关键词列表接口，才能请求回正确的列表数据
     */
    getSensitiveWordTypeList(wordTypeName) {
      let that = this;
      if (this.isNewEdition) {
        /** 新版 */
        /** 旧版本进入时，在顶级节点需要调用接口，新版本顶级节点不需要调用接口 */
        ruleTypeListApi(localStorage.getItem("Authorization"))
          .then((res) => {
            if (res && res.error && res.error.code == 200) {
              res.data.wordTypeId = "startId";
              /** 给顶级节点（企业节点）构造一个classId 用于搜索时候重置定位到顶级节点 */
              res.data.classId = "startId";
              that.setTree = [res.data];
              this.$nextTick(() => {
                console.log("that.currenId234++++", that.currenId);
                if (this.isNewEdition) {
                  if (that.currenId) {
                    this.$refs.SlotTrees.setCurrentKey(that.currenId);
                    /**  如果有wordTypeName,并且值不是createkeyWordGroupSuccess证明是编辑分类后请求的列表接口
                     * 如果wordTypeName的值是createkeyWordGroupSuccess那么就新增不需要获取wordTypeName的值
                     */
                    if (
                      wordTypeName &&
                      wordTypeName != "createkeyWordGroupSuccess"
                    ) {
                      this.getSensiListParams.wordName = wordTypeName;
                    }
                  }
                } else {
                  this.$refs.SlotTrees.setCurrentKey(that.currenId);
                }
                this.getSensitiveWordList(this.getSensiListParams);
              });
            }
          })
          .catch((err) => {
            console.log(err, "errr");
          });
      } else {
        /** 旧版接口 */
        getFirstTypeList(localStorage.getItem("Authorization"))
          .then((res) => {
            if (res && res.error && res.error.code == 200) {
              res.data.wordTypeId = "startId";
              that.setTree = [res.data];
              this.$nextTick(() => {
                this.$refs.SlotTrees.setCurrentKey(that.currenId);
              });
              console.log(
                "this.getSensiListParams++++234",
                this.getSensiListParams
              );
              /** 旧版本进入时，在顶级节点需要调用接口，新版本顶级节点不需要调用接口 */
              that.getSensitiveWordList(this.getSensiListParams);
            }
          })
          .catch((err) => {
            console.log(err, "errr");
          });
      }
    },

    /**  点击新增词组  */
    handleAdd(_node, _data, type = 1) {
      // if(!this.senGroupOption) {
      //   this.$confirm("您暂无权限新增关键词分组", {
      //     distinguishCancelAndClose: true,
      //     closeOnClickModal: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: 'warning',
      //     iconClass: 'el-icon-warning',
      //     customClass: 'delete-messege',
      //     center: true
      //   })
      //   .then((res) => {
      //   })
      //   .catch((action) => {
      //   });
      // }else {
      // if(_node.level >= 2) {
      //   this.$message.warning("当前已达到最高层级，无法新增！")
      // }else {
      console.log("_node", _node);
      console.log("_data", _data);
      /** 不知道旧的为什么要这么赋值新的不需要 */
      this.isNewEdition ? "" : (this.currenId = _data.wordTypeId);

      if (type == 1) {
        this.title = "关键词库";
        this.id = _data.classId;
      } else {
        this.title = _data.wordTypeName;
        this.id = _data.classId;
      }
      console.log(this.id);
      /** 不理解旧版这里为何要重新赋值，新版新词组时，
       *  请求关键词列表时，需要传该组的名称，
       * 如果清空的情况下，会默认请求全部，
       * 那就与当前选中的词组数据不匹配
       */
      if (!this.isNewEdition) {
        let obj = {
          wordTypeId: _data.wordTypeId,
          wordName: "",
          pageNum: 1,
          pageSize: 20,
          keyword: "",
        };
        for (let key in obj) {
          key in this.getSensiListParams
            ? (this.getSensiListParams[key] = obj[key])
            : "";
        }
        // this.getSensiListParams = JSON.parse(JSON.stringify(obj));
      }
      /** 新旧版分开走 */
      this.isNewEdition
        ? this.$refs.AddOrEditKeyWorkType.init()
        : this.$refs.OptionSenWordType.open();
      // }
      // }
    },

    /** 新增/编辑 词组成功回调 */
    createSuccess(wordTypeName) {
      // if (val == "成功") {
      if (this.isNewEdition) {
        this.getSensitiveWordTypeList(wordTypeName);
      } else {
        this.getSensitiveWordTypeList();
      }
      // }
    },

    /** 点击词组 */
    nodeClick(_data, _node, self) {
      console.log("_node.level", _node.level);
      console.log("_data", _data);
      // this.isEditBtnShowAndNewEdition = _data.classId

      if (this.isNewEdition) {
        /** 如果当前点击的classId和上一次点击的一直，则表明是点击的同一个，那么就不做重新请求*/
        if (this.currenId === _data.classId) return;
        /** 需求变更 2024.10.10 点击顶级节点查出全部数据*/
        // /** 新版本 */
        // /** 点击顶级节点不做任何操作 */

        // if (this.level == 1) {
        //   this.currenId = "startId";
        //   return (this.tableData = []);
        // }
        this.level = _node.level;
        /** 第二级 */
        if (this.level == 2) {
          this.itemTree = _data;
        }
        /** 获取当前选中项的classId */
        this.currenId = _data.classId;

        let obj = {
          wordTypeId: this.currenId,
          wordName: _data.wordTypeName,
          // wordName: "",
          pageNum: 1,
          pageSize: 20,
          classId: this.level == 2 ? _data.classId : "",
          keyword: this.getSensiListParams.keyword,
        };
        for (let key in obj) {
          key in this.getSensiListParams
            ? (this.getSensiListParams[key] = obj[key])
            : "";
        }
        // this.getSensiListParams = JSON.parse(JSON.stringify(obj));
        /** 获取关键词列表 */
        this.getSensitiveWordList(this.getSensiListParams);
      } else {
        /** 旧版本 */
        if (_node.level == 2) {
          this.itemTree = _data;
          this.level = 2;
        } else {
          this.itemTree = { ...this.setTree };
          this.level = 1;
        }
        this.currenId = _node.level == 2 ? "startId" : _data.wordTypeId;
        // this.currenId = _node.level == 2 ? "startId" : _data.wordTypeId;
        let obj = {
          wordTypeId: _node.level == 2 ? "startId" : _data.wordTypeId,
          wordName: "",
          pageNum: 1,
          pageSize: 20,
          classId: _node.level == 2 ? _data.classId : "",
          keyword: "",
        };
        console.log(" _node.level++++111+", _node.level);
        console.log(" obj++++111+", obj);
        console.log(" obj++++112221+", JSON.parse(JSON.stringify(obj)));
        // for (let key in obj) {
        //   key in this.getSensiListParams
        //     ? (this.getSensiListParams[key] = obj[key])
        //     : "";
        // }
        this.getSensiListParams = JSON.parse(JSON.stringify(obj));
        console.log("this.getSensiListParams_++++", this.getSensiListParams);
        this.getSensitiveWordList(this.getSensiListParams);
      }
    },

    /** 编辑词组  */
    handleEdit(_node, _data, type = 1) {
      // 1 父级  2子级
      // if(!this.senGroupOption) {
      //   this.$confirm("您暂无权限修改关键词分组", {
      //     distinguishCancelAndClose: true,
      //     closeOnClickModal: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: 'warning',
      //     iconClass: 'el-icon-warning',
      //     customClass: 'delete-messege',
      //     center: true
      //   })
      //   .then((res) => {
      //   })
      //   .catch((action) => {
      //   });
      // }else {
      // console.log("_data", _data)
      if (
        _data.wordTypeName == "需求捕捉词库" ||
        _data.wordTypeName == "项目需求"
      ) {
        this.$message.warning("该分类不可编辑修改！");
        return;
      } else {
        console.log("_data.currenId++++", this.currenId);
        console.log("_data++++", _data);
        if (this.isNewEdition) {
          this.currenId = _data.classId;
        } else {
          this.currenId = _data.wordTypeId;
        }

        let obj = {
          wordTypeId: this.currenId,
          wordName: "",
          pageNum: 1,
          pageSize: 20,
          keyword: "",
        };
        this.editType = type;
        if (this.isNewEdition) {
          for (let key in obj) {
            key in this.getSensiListParams
              ? (this.getSensiListParams[key] = obj[key])
              : "";
          }
        } else {
          this.getSensiListParams = JSON.parse(JSON.stringify(obj));
        }
        // this.$refs.OptionSenWordType.open(_data);

        /** 新旧接口调起不同组件*/
        this.isNewEdition
          ? this.$refs.AddOrEditKeyWorkType.init(_data)
          : this.$refs.OptionSenWordType.open(_data);

        this.title = _data.wordTypeName || "--";
      }
      // }
    },

    /** 点击删除分类 */
    handleDel(_node, _data, type = 1) {
      if (this.isNewEdition) {
        console.log(
          "this.$ref.SlotTrees.getCurrentNode()",
          this.$refs.SlotTrees.getCurrentNode().classId
        );
        console.log("row++++", _data.classId);
        console.log("_data.ruleId", _data.ruleId);
        /** id带有"#"需要进行转义 */
        // const ruleId =  _data.ruleId.replace(/\#/g,"%23");
        // const ruleId =  encodeURIComponent(_data.ruleId);
        // console.log("ruleId++++1",ruleId);
        /** 新版 */
        let tip = this.tableData.length
          ? "当前词组下的词条会被一起删除，确认删除当前词组？"
          : "是否删除该词组，删除后将不了恢复";
        this.$confirm(tip, {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        }).then((res) => {
          /** 只有二级节点可以删除 */
          if (type == 1) {
            deleteRuleApi(
              /** 已经保存到腾讯的使用ruleId，列表有携带ruleId就使用ruleId
               * 如果没有的话就使用classId
               */
              { ruleId: _data.ruleId || _data.classId },
              localStorage.getItem("Authorization")
            ).then((res) => {
              if (
                this.$refs.SlotTrees.getCurrentNode().classId === _data.classId
              ) {
                // this.getSensiListParams.classId = "";
                // this.getSensiListParams.wordTypeId = "";
                // this.getSensiListParams.classId = "";
                this.level = 1;
                this.currenId = null;
                this.tableData = [];
                let obj = {
                  wordTypeId: "",
                  wordName: _data.wordTypeName,
                  pageNum: 1,
                  pageSize: 20,
                  classId: "",
                  keyword: "",
                };
                for (let key in obj) {
                  key in this.getSensiListParams
                    ? (this.getSensiListParams[key] = obj[key])
                    : "";
                }
                // this.getSensiListParams = JSON.parse(JSON.stringify(obj));
                this.getSensitiveWordList(this.getSensiListParams);
              }
              // else {
              // this.getSensiListParams.classId = "";
              // this.getSensiListParams.wordTypeId = "";
              // this.getSensiListParams.wordName = this.itemTree.name;
              // this.getSensiListParams.wordTypeId = this.itemTree.classId;
              // this.getSensiListParams.classId = this.itemTree.classId;
              // }
              if (res && res.error && res.error.code === 200) {
                /** 删除成功重新获取分类  */
                this.getSensitiveWordTypeList();
                this.$message.closeAll();
                this.$message.success("操作成功");
              }else{
                this.$message.error(res.error.message);
              }

              /** 删除分类直接清空该分类下的数据 */
            });
          }
        });
      } else {
        /** 旧版 */
        // 1 父类  2 子类
        if (
          _data.wordTypeName == "需求捕捉词库" ||
          _data.wordTypeName == "项目需求"
        ) {
          this.$message.warning("该分类不可删除！");
          return;
        }

        // if(!this.senGroupOption) {
        //   this.$confirm("您暂无权限删除关键词分组", {
        //     distinguishCancelAndClose: true,
        //     closeOnClickModal: false,
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: 'warning',
        //     iconClass: 'el-icon-warning',
        //     customClass: 'delete-messege',
        //     center: true
        //   })
        //   .then((res) => {
        //   })
        //   .catch((action) => {
        //   });
        // }else {
        // console.log("_node",_node)
        // console.log("_data",_data)
        // if(_data.wordTypeId == '1658681960509345792'){
        //   this.$message.warning("该分类不可删除！")
        // }
        // return;
        // if(_node.level == 1) {
        //   this.$message.warning("一级分类不可删除！")
        // }
        // else {
        // `${type == 1? '当前分类下的词条会被一起删除,确认删除当前分类?' : ' 确认删除当前分类?'} `
        this.$confirm("当前分类下的关键词会被一起删除,确认删除当前分类?", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            /** 删除二级节点 */
            if (type == 1) {
              delConsultStore(
                _data.classId,
                localStorage.getItem("Authorization")
              ).then((res) => {
                this.$message.success(res.error.message);
                this.getSensiListParams.classId = "";
                this.getSensiListParams.wordTypeId = "";
                this.getSensitiveWordTypeList();
              });
            }
            /** 删除三级节点 */
            if (type == 2) {
              delFirstType(
                _data.wordTypeId,
                localStorage.getItem("Authorization")
              ).then((res) => {
                this.$message.success(res.data);
                this.getSensiListParams.classId = "";
                this.getSensiListParams.wordTypeId = "";
                this.getSensitiveWordTypeList();
              });
            }

            // this.getSensitiveWordList()
          })
          .catch((action) => {
            // this.$message("取消删除");
          });
        // }
        //   this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   delConsultStore(_data.classId,localStorage.getItem("Authorization") );
        //   this.getSensitiveWordList(this.getSensiListParams)
        //   this.$message({
        //     type: 'success',
        //     message: '删除成功!'
        //   });
        // }).catch(() => {
        //   this.$message({
        //     type: 'info',
        //     message: '已取消删除'
        //   });
        // });
        // }
        // }
      }
    },

    /**   关键词列表相关   */
    /** 获取关键词列表 */
    getSensitiveWordList(params) {
      let that = this;
      if (params.wordTypeId == "startId") {
        params.wordTypeId = "";
      }
      if (this.isNewEdition) {
        that.tableData = [];
        /** 新版 */
        ruleListApi(params, localStorage.getItem("Authorization"))
          .then((res) => {
            console.log("res+++++", res);
            if (res && res.error && res.error.code == 200) {
              that.tableData = res.data.result || [];
              console.log(" that.tableData+++", that.tableData);
              // that.pageparm.total = Number(res.data.total);
              that.wordNames = [];
              that.tableData.forEach((item) => {
                let obj = {
                  wordName: item.wordName,
                  ruleId: item.ruleId,
                };
                that.wordNames.push(obj);
              });
            }
          })
          .catch((err) => {
            console.log(err, "errr");
            this.$message.error("系统繁忙，请稍后再试");
          });
      } else {
        /** 旧版 */
        getConsultList(params, localStorage.getItem("Authorization"))
          .then((res) => {
            if (res.error.code == 200) {
              that.tableData = res.data.ruleList || [];
              that.pageparm.total = Number(res.data.total);
              that.wordNames = [];
              that.tableData.forEach((item) => {
                let obj = {
                  wordName: item.wordName,
                  ruleId: item.ruleId,
                };
                that.wordNames.push(obj);
              });
            }
          })
          .catch((err) => {
            console.log(err, "errr");
          });
      }
    },

    /** 分页回调函数 */
    callBack(parm) {
      this.getSensiListParams.pageNum = parm.currentPage;
      this.getSensiListParams.pageSize = parm.pageSize;
      this.getSensitiveWordList(this.getSensiListParams);
    },

    /** 只给新版搜索使用！！！
     * 后端说他把列表和全局搜索写一个接口太复杂了，所以现在全局的列表搜索用另一个接口
     * 该接口只提供给搜索使用
     */
    searchKeyWord() {
      this.tableData = [];
      ruleListSearchApi(
        this.getSensiListParams.keyword || "",
        localStorage.getItem("Authorization")
      ).then((res) => {
        console.log("res+++1111", res);
        if (res && res.error && res.error.code === 200) {
          this.tableData = res.data.result;
        }
      });
    },

    /** 加关键词按钮触发事件 */
    addNewSen() {
      // if(!this.senOption) {
      //   this.$confirm("您暂无权限添加关键词", {
      //     distinguishCancelAndClose: true,
      //     closeOnClickModal: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: 'warning',
      //     iconClass: 'el-icon-warning',
      //     customClass: 'delete-messege',
      //     center: true
      //   })
      //   .then((res) => {
      //   })
      //   .catch((action) => {
      //   });
      // }else {
      // this.setTree
      /** 新旧版各自走独立组件 */
      if (!this.isNewEdition) {
        /** 旧版 */
        this.$refs.addSensitive.level = this.level;
        this.$refs.addSensitive.open(this.currenId, this.setTree, this.setTree);
      } else {
        /** 新版 */
        this.$refs.addKeyWord.level = this.level;
        // this.$refs.addKeyWord.init(this.currenId, this.setTree);
        this.$refs.addKeyWord.init(this.currenId, this.setTree, this.itemTree);
        // this.$refs.addKeyWord.init(this.currenId, this.setTree, this.itemTree,this.$refs.SlotTrees);
      }

      // }
    },

    /** 新增关键词成功 */
    addSuccess(val) {
      // if (val == "成功") {
      if (this.isNewEdition) {
        /** 新版 */
        console.log("this.getSensiListParams)+++", this.getSensiListParams);
        this.getSensiListParams.wordName = this.itemTree.name;
        this.getSensiListParams.wordTypeId = this.itemTree.classId;
        this.getSensiListParams.classId = this.itemTree.classId;
        console.log("this.itemTree123", this.itemTree);
        this.getSensitiveWordList(this.getSensiListParams);
      } else {
        /** 旧版 */
        this.getSensitiveWordList(this.getSensiListParams);
      }
      // }
    },

    /** 删除关键词 */
    handleSenDel(index, row) {
      // if(!this.senOption) {
      //   this.$confirm("您暂无权限删除关键词", {
      //     distinguishCancelAndClose: true,
      //     closeOnClickModal: false,
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: 'warning',
      //     iconClass: 'el-icon-warning',
      //     customClass: 'delete-messege',
      //     center: true
      //   })
      //   .then((res) => {
      //   })
      //   .catch((action) => {
      //   });
      // }else {
      /*** 这里删除的时候，实际上调用修改接口 后端说是腾讯那边得更新覆盖*/
      if (this.isNewEdition) {
        /** 新版 */
        /** 因为腾讯不允许为词组中不存在关键词
         * 所以这里要当拥有关键词后,这里必须要限制
         * 不能删除最后一个关键词
         */
        // let messageRef = null
        if (
          this.currenId !== "startId" &&
          this.tableData &&
          this.tableData.length === 1
        ) {
          //  messageRef? this.$message().close():""
          this.$message.closeAll();
          return this.$message.warning(
            "当前词组请保留至少一个关键词,如果需要删除整组,请通过左侧列表删除"
          );
        }

        /** 取出列表的所有关键词名称组成数组 */
        let wordNameList = this.tableData.map((item) => {
          return item.wordName;
        });
        /** 去除选中的 */
        let wordName = wordNameList.filter((item) => {
          return item != row.wordName;
        });
        this.$confirm("您确定删除该关键词吗？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            let requestParams = {
              /** 需要删除的名称 */
              delWordName: row.wordName,
              /** 关键词规则名称，长度限制1~20个字符 */
              name: row.name,
              /** 分类ID */
              ruleId: row.ruleId,
              /** 去除要删除的关键词后的数组 */
              wordName,
              /** 注意！因编辑分类和删除关键词的是同一个接口， 此字段用于后端区分删除关键词和编辑分类，删除关键词该字段传true */
              delFlag: true,
            };

            if (this.currenId == "startId") delete requestParams.wordName;
            updateRuleApi(
              requestParams,
              localStorage.getItem("Authorization")
            ).then((res) => {
              if (res && res.error && res.error.code == 200) {
                this.$message.success("操作成功");
                /** 注意！！！这里都怪后端搞了两个列表接口，currenId为startId证明是搜索后的删除，此时调用搜索接口的获取列表*/
                if (this.currenId === "startId") {
                  /** 获取关键词列表 搜索 */
                  this.searchKeyWord();
                } else {
                  /** 获取关键词列表 非搜索 */
                  this.getSensitiveWordList(this.getSensiListParams);
                }
              }
            });
          })
          .catch((action) => {
            // this.$message("取消删除");
          });
      } else {
        /** 旧版 */
        console.log("row", row);
        this.$confirm("您确定删除该关键词吗？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            this.delSensitiveWord(row.ruleId);
          })
          .catch((action) => {
            // this.$message("取消删除");
          });
      }
    },

    // 删除关键词
    delSensitiveWord(params) {
      let that = this;
      delConsult(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message.success("删除关键词成功！");
            that.getSensitiveWordList(this.getSensiListParams);
          }
        })
        .catch((err) => {
          that.$message.error("删除关键词失败，请重试！");
          console.log(err, "errr");
        });
    },

    /** 下载模板  新版
     * 旧版在导入组件内部
     */
    downLoadTemplate() {
      // this.download(
      //   "/api/sensitive/consult/exportExcel",
      //   `新词库模板_${new Date().getTime()}.xlsx`,
      //   {},
      //   localStorage.getItem("Authorization"),
      //   "",
      //   "get"
      // );
      this.download(
        "/api/qywechat/exportExcel",
        `新词库模板_${new Date().getTime()}.xlsx`,
        {},
        localStorage.getItem("Authorization"),
        "",
        "get"
      );
    },

    // 导入结束后关闭弹层
    handleVisiImport(type) {
      console.log("type", type);
      this.dialogVisit = false;
      // console.log(type)
      if (type) {
        /** 刷新分类列表函数，并刷新关键词列表接口 */
        this.getSensitiveWordTypeList();
      }
    },

    /** 关键词搜索框的blur事件 */
    onInputBlur() {
      /** 新版 */
      if (this.isNewEdition) {
        /** 搜索为全部关键词的模糊搜索 不区分词组
         * 所以每次搜索需要重置词组列表定位到顶级节点
         * 表明为全局搜索
         */
        /** 把数据置为顶级节点数据 */
        this.level = 1;
        this.getSensiListParams.pageNum = 1;
        this.getSensiListParams.wordTypeId = "";
        this.getSensiListParams.wordName = "";
        this.getSensiListParams.classId = "";
        /** 重置当前选中分类节点 */
        this.currenId = "startId";
        /** 设置当前节点到指定分类树的位置 */
        this.$refs.SlotTrees.setCurrentKey(this.currenId);
        // this.getSensitiveWordList(this.getSensiListParams);
        this.searchKeyWord(this.getSensiListParams);
      } else {
        /** 旧版 */
        this.getSensiListParams.pageNum = 1;
        this.getSensitiveWordList(this.getSensiListParams);
      }
    },

    /**旧版独有 同步院内分类词 */
    handleAsyncItem() {
      this.$confirm("确定执行该操作吗?", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        iconClass: "el-icon-warning",
        customClass: "delete-messege",
        center: true,
      }).then((res) => {
        asyncItem(localStorage.getItem("Authorization"))
          .then((res) => {
            this.$message.success(`成功同步${res.data}条`);
          })
          .catch(() => {
            this.$message.error(`操作失败，请重新尝试`);
          });
      });
    },
  },

  watch: {
    /**  2024.09.26 旧代码 权限的代码好像，好像没接 */
    btnAuthority: {
      handler(newVal, oldVal) {
        // console.log('XXXXXXXX',newVal);
        if (newVal.length > 0) {
          newVal.forEach((item) => {
            if (item.pname == "关键词设置") {
              let senBtnAuthority = item.cfunBu;
              if (senBtnAuthority.indexOf("kxzbjscfz") != -1) {
                // 可新增、编辑、删除分组
                this.senGroupOption = true;
              } else {
                this.senGroupOption = false;
              }
              if (senBtnAuthority.indexOf("kxzscmgc") != -1) {
                // 可新增、删除关键词
                this.senOption = true;
              } else {
                this.senOption = false;
              }
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    /**  2024.09.26 旧代码 权限的代码好像，好像没接 */
    btnAuthority() {
      return this.$store.state.tagsView.roleAuthrority;
    },

    /** 新旧版悬停是否显示编辑按钮 */
    // isEditBtnShowAndNewEdition(){
    //   if(this.isNewEdition){
    //     return this.isEditBtnShow
    //   }else{
    //     return true
    //   }

    // }
  },

  /** 生命周期 */
  async created() {
    // await  getSessionVersion(localStorage.getItem("Authorization")).then((res) => {
    //     if (res && res.error && res.error.code === 200) {
    //       this.isNewEdition = res.data
    //       console.log("dsfsdfsfsdf1111",this.isNewEdition);
    //       window.localStorage.setItem("isNewEdition", this.isNewEdition);
    //     } else {
    //       // this.$message.error("获取版本参数失败")
    //     }
    //   }).catch((err) => {
    //     // this.$message.error("获取版本参数失败")
    //     console.log("新旧版本参数获取失败", err);
    //   });
    // this.isNewEdition = window.localStorage.getItem("isNewEdition");
    /** 因为新版没有这几个功能，后端说路由是写死数据库的，不好去掉，也不想加接口，就给增加工作量 */
    // if (this.isNewEdition) {
    //   this.$confirm("功能正在开发中，敬请期待", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //     showClose: false,
    //     showCancelButton: false,
    //     closeOnClickModal: false,
    //     center: true,
    //   })
    //     .then(() => {
    //       /** 关闭当前路由 */
    //       this.$store.dispatch("tagsView/delView", this.$route);
    //       /** 跳转index页面 */
    //       this.$router.push({ path: "/index" });
    //     })
    //     .catch(() => {});
    //   return;
    // }

    /** 获取进入系统后获取到的新旧版进行判断， */
    await this.getVersion();
    /** 初始化分页 */
    this.getSensiListParams.pageNum = this.pageparm.currentPage;
    this.getSensiListParams.pageSize = this.pageparm.pageSize;
  },
};
</script>

<style lang="scss" scoped>
/* common */

// 显示按钮
.show-btns {
  opacity: 1;
}
/* common end */
.sen-setting-container {
  height: 100%;
  width: 100%;
  display: flex;
  object-fit: fill;
  /deep/.el-tree-node__content {
    height: auto;
  }
  .main-container {
    padding: 0 0 0 10px !important;
    .main-head {
      margin-bottom: 10px;
      .download-btn {
        font-size: 12px;
        color: #aaa;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
// 自定义节点
.comp-tr-node {
  // label
  flex: 1;
  display: flex;
  .template {
    display: flex;
    flex: 1;
    width: 0;
    align-items: center;
    justify-content: flex-start;
  }
  .comp-tr-node--name {
    flex: 1;
    font-size: 14px;
    padding: 8px 2px 8px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // button
  .comp-tr-node--btns {
    opacity: 0;
    transition: opacity 0.1s;
    display: flex;
    align-items: center;
    margin-right: 4px;
    justify-content: flex-start;
    .el-button {
      transform: scale(0.8); // 缩小按钮
      & + .el-button {
        margin-left: -1px;
      }
    }
  }
}
// 高亮显示按钮
.is-current {
  & > .el-tree-node__content {
    height: auto;
    .comp-tr-node--btns {
      @extend .show-btns;
    }
  }
}
// 悬浮显示按钮
.el-tree-node__content {
  height: auto;
  &:hover {
    .comp-tr-node--btns {
      @extend .show-btns;
    }
  }
}
.out-wrap {
  width: 100%;
  height: 100%;
}
// 删除信息
.delete-messege {
  .el-icon-warning {
    color: #1296db !important;
    font-size: 40px;
    transform: rotate(180deg);
  }
}
</style>
